<template>
<div class="ParkCompleteSet">
  <div class="header align-center-main">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ serviceMsg.serviceName }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ serviceChildName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <ul v-if="this.currentParkId == 1003" class="nav clearfix">
      <li class="boxShadow box1" :class="{'select' : action === item.type }" v-for="(item, index) in tabList" :key="index" @click="Jump(item.type)">
        <img :src="item.picUrl" alt="">
        <h3>{{ item.serviceName }}</h3>
      </li>
    </ul>
    <ul v-else class="nav clearfix">
      <li class="boxShadow box1" :class="{'select' : action === item.type }" v-for="(item, index) in arrlist" :key="index" @click="Jump(item.type)">
        <img :src="item.picUrl" alt="">
        <h3>{{ item.serviceName }}</h3>
      </li>
    </ul>
  </div>
  <div class="content">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import {
  mapGetters
} from "vuex";

export default {
  data() {
    return {
      huodong: true,
      meishi: false,
      zhuanxiang: false,
      routerName: "园区活动",
      tabList: [],
      arrlist: [],
      action: 0,
      serviceMsg: {}
    };
  },
  methods: {
    getList() {
      this.$http
        .post(`${this.URL_PREFIX}/app/get/park/service/list`, {
          parkId: this.currentParkId,
          parentId: this.serviceMsg.serviceId
        })
        .then(response => {
          const res = response.data;
          if (res.resCode === "10000") {
            this.tabList = res.resData ? res.resData.pageList : [];
            this.arrlist = this.tabList.slice(1);
            if (this.$route.path.split("/")[3]) {
              this.jump2(this.$route.path.split("/")[3]);
            } else {
              this.Jump(res.resData.pageList[0].type);
            }
          }
        });
    },
    Jump(type) {
      this.action = type;
      if (type === 13) {
        this.$router.push({
          path: `/navigator/parkCompleteSet/activity`
        });
      } else if (type === 9) {
        this.$router.push({
          path: `/navigator/parkCompleteSet/foodCourt`
        });
      } else if (type === 14) {
        this.$router.push({
          path: `/navigator/parkCompleteSet/exclusiveActivities`
        });
      }
    },
    jump2(path) {
      if (path === "activity") {
        this.action = 13;
      } else if (path === "foodCourt") {
        this.action = 9;
      } else {
        this.action = 14;
      }
    }
  },
  created() {
    if (this.parkServiceList.length) {
      this.serviceMsg = this.parkServiceList.find(val => {
        return val.serviceFlag === 6;
      });
      this.getList();
    }
  },
  watch: {
    $route: {
      handler() {
        this.jump2(this.$route.path.split("/")[3]);
      }
    }
  },
  computed: {
    ...mapGetters(["currentParkId", "parkServiceList"]),
    serviceChildName() {
      const arrIndex = this.tabList.findIndex(val => {
        return this.action === val.type;
      });
      if (arrIndex !== -1) {
        return this.tabList[arrIndex].serviceName;
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.ParkCompleteSet {
  padding-bottom: 18px;
  background-color: #f6f6f6;
}

p {
  display: inline-block;
  font-size: 24px;
  color: #333;
}

.box1 {
  // margin-top: 22px;
  margin-right: 18px;
  width: 285px;
  height: 88px;
  display: inline-block;
  line-height: 88px;
  background-color: white;
  text-align: center;
  border: 1px solid #fff;
  box-sizing: border-box;
  cursor: pointer;
  span,
  i,
  img,
  p {
    display: inline-block;
    vertical-align: middle;
  }
  .text {
    width: 200px;
  }
  .img_b {
    margin-left: 30px;
    width: 44px;
    height: 44px;
  }
}

.select {
  border-color: red;
}

.content {
  margin-top: 40px;
}

.icon {
  width: 44px;
  height: 41px;
}

.nav {
  margin-bottom: 26px;
  li {
    width: 380px;
    padding: 0 30px;
    height: 88px;
    float: left;
    background-color: #fff;
    display: flex;
    justify-content: left;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    &:nth-of-type(4n) {
      margin-right: 0;
    }
    &.select {
      border: 1px solid red;
    }
    h3 {
      font-size: 24px;
      font-weight: 600;
      width: 180px;
      text-align: left;
    }
    img {
      // width: 44px;
      height: 44px;
      margin-right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/parkCompleteSet/ParkCompleteSet.vue